import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { SEARCH_RESULT_LIMIT } from '../../constants/SearchConstants';
import { searchActions } from '../../redux/search/actions/SearchActions.creators';
import { makeGetSearchContentState, makeGetSearchSuggestionsState, makeGetSearchBrandsState, makeGetSearchCategoriesState, makeGetSearchBrandAsCategoriesState, } from '../../redux/search/selectors/SearchSelector';
import { getSearchItemGrouping } from '../../util/SearchUtil';
import { NewMenuSearch } from '../menu-search/NewMenuSearch';
const MenuSearchContainer = ({ createAdobeAnalyticsSetSearchTermAction, queryValue, searchBrandAsCategories, searchBrands, searchCategories, searchContent, searchFetchWithoutProductsAction, searchKeywords, suggestionsParentLink, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.navigation);
    const [searchValue, setSearchValue] = useState(queryValue);
    const [maxAmountEnhancedItems, setMaxAmountEnhancedItems] = useState(SEARCH_RESULT_LIMIT.FOR_1_SEARCH_CHARACTER);
    const setSearchTerm = (searchTerm) => {
        if (searchTerm) {
            searchFetchWithoutProductsAction(searchTerm);
            switch (searchTerm.trim().length) {
                case 1:
                    setMaxAmountEnhancedItems(SEARCH_RESULT_LIMIT.FOR_1_SEARCH_CHARACTER);
                    break;
                case 2:
                    setMaxAmountEnhancedItems(SEARCH_RESULT_LIMIT.FOR_2_SEARCH_CHARACTER);
                    break;
                default:
                    setMaxAmountEnhancedItems(SEARCH_RESULT_LIMIT.FOR_MORE_THEN_2_SEARCH_CHARACTER);
                    break;
            }
        }
        else {
            setMaxAmountEnhancedItems(SEARCH_RESULT_LIMIT.FOR_1_SEARCH_CHARACTER);
        }
        setSearchValue(searchTerm);
    };
    const menuSearchItemGrouping = getSearchItemGrouping({
        keywords: searchKeywords,
        categories: searchCategories,
        brands: searchBrands,
        brandAsCategories: searchBrandAsCategories,
        content: searchContent,
    }, maxAmountEnhancedItems, t);
    return (_jsx(NewMenuSearch, { createAdobeAnalyticsSetSearchTermAction: createAdobeAnalyticsSetSearchTermAction, menuSearchItemGrouping: menuSearchItemGrouping, setSearchValue: setSearchTerm, suggestionsParentLink: suggestionsParentLink, searchValue: searchValue }));
};
const makeMapStateToProps = () => {
    const getSearchContentState = makeGetSearchContentState();
    const getSearchKeywordsSuggestionsState = makeGetSearchSuggestionsState();
    const getSearchBrandsSuggestionsState = makeGetSearchBrandsState();
    const getSearchCategoriesSuggestionsState = makeGetSearchCategoriesState();
    const getSearchBrandAsCategoriesState = makeGetSearchBrandAsCategoriesState();
    const mapStateToProps = (state, ownProps) => ({
        searchKeywords: getSearchKeywordsSuggestionsState(state, ownProps === null || ownProps === void 0 ? void 0 : ownProps.suggestionsParentLink),
        searchBrands: (!!ownProps.brandsParentLink && getSearchBrandsSuggestionsState(state, ownProps.brandsParentLink)) || [],
        searchCategories: (!!ownProps.categoriesParentLink && getSearchCategoriesSuggestionsState(state, ownProps.categoriesParentLink)) ||
            [],
        searchBrandAsCategories: (!!ownProps.categoriesParentLink && getSearchBrandAsCategoriesState(state, ownProps.categoriesParentLink)) || [],
        searchContent: getSearchContentState(state),
    });
    return mapStateToProps;
};
const mapDispatchToProps = {
    searchFetchWithoutProductsAction: searchActions.createFetchWithoutProductsAction,
    createAdobeAnalyticsSuccessProductAction: searchActions.createAdobeAnalyticsSuccessProductAction,
    createAdobeAnalyticsSetSearchTermAction: searchActions.createAdobeAnalyticsSetSearchTermAction,
};
export default connect(makeMapStateToProps, mapDispatchToProps)(MenuSearchContainer);
